import { render } from "./HelpUpdatePart.vue?vue&type=template&id=0a933556"
import script from "./HelpUpdatePart.vue?vue&type=script&lang=js"
export * from "./HelpUpdatePart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__